import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "noConfirmarMas";
export type Buttons = "aceptar" | "cancelar";

export const deleteFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "noConfirmarMas",
      label: "No volver a preguntar en esta sesión",
      bts: { mCol: 12 },
      component: ICheckBuilder
    }
  ],
  buttons: [
    {
      name: "cancelar",
      label: "Cancelar",
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "aceptar",
      label: "Eliminar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {
        color: "danger"
      }
    }
  ],
  validations: {},
  rows: [["noConfirmarMas"], ["cancelar", "aceptar"]]
};
